module.exports = __webpack_public_path__ + "img/fondo-banner-principal.9ea6b88e.png";